import { login as userLoginApi } from '@/api/user/auth'
import { adminLogin as adminLoginApi } from '@/api/admin/auth'
import { ROLES, fetchMyPermissions, clearPermissionCache } from '@/utils/permission'

const state = {
  token: localStorage.getItem('token') || '',
  adminToken: localStorage.getItem('adminToken') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  adminInfo: JSON.parse(localStorage.getItem('adminInfo') || '{}'),
  role: localStorage.getItem('role') || '',
  adminRole: localStorage.getItem('adminRole') || '',
  adminPermissions: JSON.parse(localStorage.getItem('adminPermissions') || '[]')
}

const getters = {
  token: state => state.token,
  adminToken: state => state.adminToken,
  userInfo: state => state.userInfo,
  adminInfo: state => state.adminInfo,
  role: state => state.role,
  adminRole: state => state.adminRole,
  adminPermissions: state => state.adminPermissions,
  isAdmin: state => state.role === 'ADMIN' || state.role === 'CENTER',
  isUser: state => state.role === 'USER' || state.role === 'STAFF',
  isSuperAdmin: state => state.adminRole === ROLES.SUPER_ADMIN,
  isSubAdmin: state => state.adminRole === ROLES.SUB_ADMIN,
  isServiceCenter: state => state.adminRole === ROLES.SERVICE_CENTER
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_ADMIN_TOKEN(state, token) {
    state.adminToken = token
    localStorage.setItem('adminToken', token)
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SET_ADMIN_INFO(state, adminInfo) {
    state.adminInfo = adminInfo
    localStorage.setItem('adminInfo', JSON.stringify(adminInfo))
  },
  SET_ROLE(state, role) {
    state.role = role
    localStorage.setItem('role', role)
  },
  SET_ADMIN_ROLE(state, role) {
    state.adminRole = role
    localStorage.setItem('adminRole', role)
  },
  SET_ADMIN_PERMISSIONS(state, permissions) {
    state.adminPermissions = permissions
    localStorage.setItem('adminPermissions', JSON.stringify(permissions))
  },
  CLEAR_USER(state) {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  },
  CLEAR_ADMIN(state) {
    state.adminToken = ''
    state.adminInfo = {}
    state.adminRole = ''
    state.adminPermissions = []
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminInfo')
    localStorage.removeItem('adminRole')
    localStorage.removeItem('adminPermissions')
    clearPermissionCache()
  }
}

const actions = {
  login({ commit }, userData) {
    return new Promise((resolve, reject) => {
      userLoginApi(userData).then(res => {
        const { token, userInfo } = res.data
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', userInfo)
        commit('SET_ROLE', userInfo.role)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  adminLogin({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      adminLoginApi(userData).then(async res => {
        const { token, role } = res.data
        commit('SET_ADMIN_TOKEN', token)
        commit('SET_ADMIN_ROLE', role || ROLES.SUPER_ADMIN)
        commit('SET_ADMIN_INFO', res.data)
        // 登录成功后获取权限
        await dispatch('fetchPermissions')
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取当前用户权限
  async fetchPermissions({ commit }) {
    try {
      const permissions = await fetchMyPermissions()
      commit('SET_ADMIN_PERMISSIONS', permissions)
      return permissions
    } catch (error) {
      console.error('获取权限失败:', error)
      return []
    }
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      commit('CLEAR_USER')
      commit('CLEAR_ADMIN')
      resolve()
    })
  }
}

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
}
